/* eslint-disable no-console */
import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import React, { Suspense } from 'react';

import { useFindingDataConfig } from './FindingsDataGrid.config';

const FindingsDataGrid = () => {
  const { config, data, loading } = useFindingDataConfig();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default FindingsDataGrid;
